<template>
    <div>
        <el-dialog align-center v-model="state.dialogVisible" :title="title" width="800" draggable>
            <div class="userAdd_man">
                    <el-form ref="ruleForm" label-width="auto" :model="form" :rules="rules" class="userFrom">
                        <el-col :span="12" style="margin-bottom: 20px;">
                            <el-form-item :label="t('feedbackList.colTitle')" prop="title">
                                {{ row.title }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" style="margin-bottom: 20px;">
                            <el-form-item :label="t('feedbackReply.reporter')" prop="real_name">
                                {{ row.real_name }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" style="margin-bottom: 20px;">
                            <el-form-item :label="t('feedbackList.colType')" prop="type">
                                {{ listToMap(typeOptions, {})[row.type] }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" style="margin-bottom: 20px;">
                            <el-form-item :label="t('feedbackList.colStatus')" prop="type">
                                <el-tag :type="statusTypeMap[row.status]" size="small">{{ listToMap(statusOptions, {})[row.status] }}</el-tag>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" style="margin-bottom: 20px;">
                            <el-form-item :label="t('feedbackReply.contact')" prop="contact_info">
                                {{ row.contact_info }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" style="margin-bottom: 20px;">
                            <el-form-item :label="t('feedbackReply.content')" prop="content">
                                {{ row.content }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" style="margin-bottom: 20px;">
                            <el-form-item :label="t('feedbackReply.relatedImages')" prop="content">
                                <div style="display: flex;">
                                    <img v-for="item in imgList" :src="item.url" alt="" class="pic">
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="t('feedbackReply.replyContent')" prop="reply_content">
                                <el-input v-model="form.reply_content" type="textarea" :rows="10" />
                            </el-form-item>
                        </el-col>

                    </el-form>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="state.dialogVisible = false">{{ t('common.cancel') }}</el-button>
                    <el-button type="primary" @click="submit">
                        {{ t('common.confirm') }}
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import {
    reactive,
    ref,
    defineEmits,
    defineProps,
    defineExpose,
    toRaw,
    computed
} from "vue";
import { ElMessage } from "element-plus";
import { replyApi } from "@/api/feedback";
import { listToMap } from "@/utils/utils";
import { usePageI18n } from "@/composables/usePageI18n.js";

const emit = defineEmits([]);
const props = defineProps({
    title: {
        type: String,
        default: "",
    },
    row: {
        type: Object,
        default: () => ({}),
    },
    typeOptions: {
        type: Array,
        default: () => [],
    },
    statusOptions: {
        type: Array,
        default: () => [],
    },
});

const applyLabels = () => {
    if (rules.reply_content?.[0]) {
        rules.reply_content[0].message = t('feedbackReply.needReply');
    }
};
const { t } = usePageI18n(applyLabels);

const imgList = computed(() => {
    try {
        return JSON.parse(props.row.picture || '[]')
    } catch {
        return []
    }
})

const statusTypeMap = {
    0: 'danger',
    1: 'success',
}

const form = reactive({
    "id": 0,
    "replied_by": 0,
    "replied_name": "",
    "reply_content": ""
});
const rules = reactive({
    reply_content: [{ required: true, message: "", trigger: "blur" }],
});

const state = reactive({
    dialogVisible: false,
});

const open = () => {
    state.dialogVisible = true;
};

const ruleForm = ref(null)
const submit = () => {
    ruleForm.value.validate((valid) => {
        if (valid) {
            const { user } = JSON.parse(localStorage.getItem("user"));
            const params = JSON.stringify({
                ...toRaw(form),
                "replied_by": user.users.id,
                "replied_name": user.users.realName,
            })
            replyApi(params).then(res => {
                if (res.code === 200) {
                    ElMessage.success(t('feedbackReply.replySuccess'))
                    emit('refresh')
                    state.dialogVisible = false
                }
            })
        } else {
            return false;
        }
    });
};

applyLabels();

defineExpose({ open, state });
</script>

<style lang="less" scoped>
.userAdd_man {
    min-height: 200px;
    max-height: 600px;
    overflow: auto;
    padding: 0 30px;
}

.userFrom {
    display: flex;
    flex-wrap: wrap;
}

.el-form-item {
    margin-bottom: 0;
}

.pic {
    width: 150px;
    height: 150px;
    border-radius: 10px;
    margin-left: 10px;
}
</style>
